import { useEffect, useState } from "react";

const navLinks = [
  { label: "主角介绍", href: "#protagonist" },
  { label: "角色设定", href: "#roles" },
  { label: "人物关系", href: "#relationships" },
  { label: "剧情看点", href: "#arcs" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap" aria-label="返回首页">
          <span className="grid w-9 h-9 place-items-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-home-heart-fill w-4 h-4 flex items-center justify-center"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">
            继母与继姐<span className="text-primary-600">漫画</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#about"
            className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap transition-colors"
          >
            关于本站
          </a>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            联系我们
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className="grid w-10 h-10 place-items-center rounded-md text-foreground-800 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50/95 backdrop-blur px-4 py-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              关于本站
            </a>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              联系我们
            </a>
          </div>
        </div>
      )}
    </header>
  );
}